import React, { useEffect, useRef, useState } from 'react'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { GET } from 'rest/request'
import Loading from '../Loading'
import { api } from 'rest/urls'
import Popup from './Popup'

export type ConsentType = 'privacy' | 'terms'
interface ConsentPreviewModalProps {
  type: ConsentType
  endpoint?: string
  close?: basic.BasicFunc
}

const ConsentPreviewPopup: React.FC<ConsentPreviewModalProps> = ({ type, endpoint, close }) => {
  const [isLoading, setLoading] = useState(true)
  const iframeRef = useRef<HTMLIFrameElement>(null)

  const { t } = useTranslation('basic')
  const getDocument = async (endpoint: string) => {
    try {
      const response = await GET(endpoint)
      setLoading(false)
      if (typeof response === 'string') {
        const contentDocument = iframeRef.current?.contentDocument
        if (contentDocument) {
          contentDocument.open()
          contentDocument.write(response)
          contentDocument.close()
        }
      }
    } catch (error) { }
  }

  useEffect(() => {
    const url = endpoint || `${api.replace('/v1/', '')}/${type}`
    getDocument(url)
  }, [type, endpoint])

  return (
    <Popup
      centered
      close={close}>
      <div className='popup--consent'>
        <div className='popup__title'>
          <div>{t(type)}</div>
        </div>
        <div className='popup__frame__container'>
          <iframe
            title={t(type)}
            ref={iframeRef}
          />
          {isLoading && <Loading middleOfPage />}
        </div>
        <div className='popup__buttons'>
          <BackBtn action={close} />
        </div>
      </div>
    </Popup>
  )
}

export default ConsentPreviewPopup